import { PureComponent } from 'react';
import AsyncNotInstalledAlert from '../../code-splitting/components/AsyncNotInstalledAlert';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import UIScriptloaderInstallModalPanel from 'ui-addon-scriptloader/UIScriptloaderInstallModalPanel';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class InstallCodePaneWrapper extends PureComponent {
  constructor(...args) {
    super(...args);
    this.hideInstallCodeModalAndFetchStatus = () => {
      this.props.hideInstallCodePane();
      this.props.fetchInstallStatus();
    };
    this.renderPaneComponent = () => {
      return /*#__PURE__*/_jsx(UIScriptloaderInstallModalPanel, {
        onReject: this.hideInstallCodeModalAndFetchStatus,
        onConfirm: this.hideInstallCodeModalAndFetchStatus,
        showStatus: true
      });
    };
  }
  renderPaneOrAlert() {
    const {
      focusedThreadId,
      paneIsVisible
    } = this.props;
    if (paneIsVisible) {
      return this.renderPaneComponent();
    }
    if (focusedThreadId) {
      return /*#__PURE__*/_jsx(AsyncNotInstalledAlert, {
        threadId: focusedThreadId
      });
    }
    return null;
  }
  render() {
    return /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      blockSize: "100%",
      children: /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "stretch",
        inlineSize: "100%",
        blockSize: "100%",
        "data-test-id": "install-code-pane-wrapper",
        children: [this.renderPaneOrAlert(), /*#__PURE__*/_jsx(Box, {
          flexGrow: 1,
          flexBasis: 0,
          minBlockSize: "0",
          children: /*#__PURE__*/_jsx(Flex, {
            inlineSize: "100%",
            blockSize: "100%",
            flexDirection: "column",
            display: this.props.paneIsVisible ? 'none' : 'flex',
            children: this.props.children
          })
        })]
      })
    });
  }
}
InstallCodePaneWrapper.displayName = 'InstallCodePaneWrapper';
export default InstallCodePaneWrapper;